import axios from '@axios'

export default {
    namespaced: true,
    state: {
        roles: [],
        departamentos: [],
        areas: [],
        depart: [],
        secciones: [],
        seccionesJer: [],
        provincias: [],
        ciudades: [],
        allTiposPermiso: [],
        permisosSalida: [],
        permisosVisualizar: null,
        tiposPermiso: [],
        personalProduccion: [],
        establecimientosRRHH: [],
        fabricasRRHH: [],
        reportePermisosEmpleados: [],
        permisosEstudio: [],
        divisiones: [],
        tiposFalta: [],
        empresasComplementarias: [],
        generosAll: [],
        estadoCivilAll: [],
        obtenerComplementarios: [],
        tipoCargasFamiliares: [],
        tipo_identificacion: [],
        cargasfamiliarescomplementario: [],
        tipoDocumentos: [],
        documentosComplementarios: [],
        examenesMedicos: [],
        rolesExamenesMedicos: [],
        examenXseccion: [],
        permisosEmpresasCompl: [],
        jerarquias: [],
        naves: [],
        sucursalIess: [],
        subDepartamentos: [],
        cargos: [],
        tiposContrato: [],
    },
    getters: {
        getRoles(state) {
            return state.roles
        },

        getDepartamentos(state) {
            return state.departamentos
        },

        getAreas(state) {
            return state.areas
        },

        getDepart(state) {
            return state.depart
        },

        getSecciones(state) {
            return state.secciones
        },

        getSeccionesJer(state) {
            return state.seccionesJer
        },

        getProvincias(state) {
            return state.provincias
        },

        getCiudades(state) {
            return state.ciudades
        },

        getAllTiposPermiso(state) {
            return state.allTiposPermiso
        },

        getPermisosSalida(state) {
            return state.permisosSalida
        },

        getPermisosParaVisualizar(state) {
            return state.permisosVisualizar
        },

        getTiposPermiso(state) {
            return state.tiposPermiso
        },

        getPersonalProduccion(state) {
            return state.personalProduccion
        },

        getEstablecimientosRRHH(state) {
            return state.establecimientosRRHH
        },

        getFabricasRRHH(state) {
            return state.fabricasRRHH
        },

        getReportePermisosEmpleados(state) {
            return state.reportePermisosEmpleados
        },

        getPermisosEstudio(state) {
            return state.permisosEstudio
        },

        getDivisiones(state) {
            return state.divisiones
        },

        getTiposFalta(state) {
            return state.tiposFalta
        },

        getEmpresas(state) {
            return state.empresasComplementarias
        },
        getGenerosAll(state) {
            return state.generosAll
        },
        getEstadoCivilAll(state) {
            return state.estadoCivilAll
        },
        getComplementarios(state) {
            return state.obtenerComplementarios
        },
        getTipoCargasFamiliares(state) {
            return state.tipoCargasFamiliares
        },
        getTipoIdentificacion(state) {
            return state.tipo_identificacion
        },
        getComplementario(state) {
            return state.complementario
        },
        getCargasFamiliaresComplementario(state) {
            return state.cargasfamiliarescomplementario
        },
        getTipoDocumentos(state) {
            return state.tipoDocumentos
        },
        getDocumentosComplementario(state) {
            return state.documentosComplementarios
        },
        getExamenesMedicos(state) {
            return state.examenesMedicos
        },
        getRolesExamenesMedicos(state) {
            return state.rolesExamenesMedicos
        },
        getExamenesPorSeccion(state) {
            return state.examenXseccion
        },
        getPermisoEmpresasComplementario(state) {
            return state.permisosEmpresasCompl
        },
        getJerarquias(state) {
            return state.jerarquias
        },
        getNaves(state) {
            return state.naves
        },
        getSucursalIess(state) {
            return state.sucursalIess
        },
        getSubDepartamentos(state) {
            return state.subDepartamentos
        },
        getCargos(state) {
            return state.cargos
        },
        getTiposContrato(state) {
            return state.tiposContrato
        },
    },
    mutations: {
        SET_ROLES(state, roles) {
            state.roles = roles
        },

        SET_DEPARTAMENTOS(state, departamentos) {
            state.departamentos = departamentos
        },

        SET_AREAS(state, areas) {
            state.areas = areas
        },

        SET_DEPART(state, depart) {
            state.depart = depart
        },

        SET_SECCIONES(state, secciones) {
            state.secciones = secciones
        },

        SET_SECCIONES_JER(state, seccionesJer) {
            state.seccionesJer = seccionesJer
        },

        SET_PROVINCIAS(state, provincias) {
            state.provincias = provincias
        },

        SET_CIUDADES(state, ciudades) {
            state.ciudades = ciudades
        },

        SET_ALL_TIPOS_PERMISO(state, allTiposPermiso) {
            state.allTiposPermiso = allTiposPermiso
        },

        SET_PERMISOS_SALIDA(state, permisosSalida) {
            state.permisosSalida = permisosSalida
        },

        SET_PERMISOS_PARA_VISUALIZAR(state, permisosVisualizar) {
            state.permisosVisualizar = permisosVisualizar
        },

        SET_TIPOS_PERMISO(state, tiposPermiso) {
            state.tiposPermiso = tiposPermiso
        },

        SET_PERSONAL_PRODUCCION(state, personalProduccion) {
            state.personalProduccion = personalProduccion
        },

        SET_ESTABLECIMIENTOS_RRHH(state, establecimientosRRHH) {
            state.establecimientosRRHH = establecimientosRRHH
        },

        SET_FABRICAS_RRHH(state, fabricasRRHH) {
            state.fabricasRRHH = fabricasRRHH
        },

        SET_REPORTE_PERMISOS_EMPLEADOS(state, reportePermisosEmpleados) {
            state.reportePermisosEmpleados = reportePermisosEmpleados
        },

        SET_PERMISOS_ESTUDIO(state, permisosEstudio) {
            state.permisosEstudio = permisosEstudio
        },

        SET_DIVISIONES(state, divisiones) {
            state.divisiones = divisiones
        },

        SET_TIPOS_FALTA(state, tiposFalta) {
            state.tiposFalta = tiposFalta
        },

        SET_EMPRESAS_COMPLEMENTARIAS(state, empresasComplementarias) {
            state.empresasComplementarias = empresasComplementarias
        },
        SET_ESTADO_CIVIL_ALL(state, estadoCivilAll) {
            state.estadoCivilAll = estadoCivilAll
        },
        SET_GENEROS_ALL(state, generosAll) {
            state.generosAll = generosAll
        },
        SET_EMPLEADOS_COMPLEMENTARIOS(state, obtenerComplementarios) {
            state.obtenerComplementarios = obtenerComplementarios
        },

        SET_TIPO_CARGA_FAMILIAR(state, tipoCargasFamiliares) {
            state.tipoCargasFamiliares = tipoCargasFamiliares
        },
        SET_TIPO_IDENTIFICACION(state, tipo_identificacion) {
            state.tipo_identificacion = tipo_identificacion
        },
        SET_CARGA_FAMILIAR_COMPLEMENTARIOS(state, cargasfamiliarescomplementario) {
            state.cargasfamiliarescomplementario = cargasfamiliarescomplementario
        },
        SET_TIPO_DOCUMENTO(state, tipoDocumentos) {
            state.tipoDocumentos = tipoDocumentos
        },
        SET_DOCUMENTOS_COMPLEMENTARIOS(state, documentosComplementarios) {
            state.documentosComplementarios = documentosComplementarios
        },
        SET_EXAMENES_MEDICOS(state, examenesMedicos) {
            state.examenesMedicos = examenesMedicos
        },
        SET_ROLES_EXAMENES_MEDICOS(state, rolesExamenesMedicos) {
            state.rolesExamenesMedicos = rolesExamenesMedicos
        },
        SET_EXAMEN_X_SECCION(state, examenXseccion) {
            state.examenXseccion = examenXseccion
        },
        SET_PERMISOS_EMPRESAS_COMP(state, permisosEmpresasCompl) {
            state.permisosEmpresasCompl = permisosEmpresasCompl
        },
        SET_JERARQUIAS(state, jerarquias) {
            state.jerarquias = jerarquias
        },
        SET_NAVES(state, naves) {
            state.naves = naves
        },
        SET_SUCURSAL_IESS(state, sucursalIess) {
            state.sucursalIess = sucursalIess
        },
        SET_SUBDEPARTAMENTOS(state, subDepartamentos) {
            state.subDepartamentos = subDepartamentos
        },
        SET_CARGOS(state, cargos) {
            state.cargos = cargos
        },
        SET_TIPOS_CONTRATO(state, tiposContrato) {
            state.tiposContrato = tiposContrato
        },
    },
    actions: {
        fetchRoles({ commit }) {
            commit('SET_ROLES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/roles')
                    .then(response => {
                        commit('SET_ROLES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDepartamentos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/departamentos')
                    .then(response => {
                        commit('SET_DEPARTAMENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAreas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/areas/${data}`)
                    .then(response => {
                        commit('SET_AREAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDepart({ commit }, cod_rol) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/depart/${cod_rol}`)
                    .then(response => {
                        commit('SET_DEPART', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSecciones({ commit }, cod_rol) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/secciones/${cod_rol}`)
                    .then(response => {
                        commit('SET_SECCIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProvincias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/provincias')
                    .then(response => {
                        commit('SET_PROVINCIAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCiudades({ commit }, provincia) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/ciudades/${provincia}`)
                    .then(response => {
                        commit('SET_CIUDADES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPreingreso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/registrarPreingreso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postReclutamiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/registrarReclutamiento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCedula(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/verificarCedula/${data.cedula}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCedulaGenerales(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/verificarCedulaGenerales/${data.cedula}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCedulaReclutamiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/rrhh/verificarCedulaReclutado/${data.cedula}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchConsultarSeccionesJer({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/consultarSeccionesJer/', { params: data })
                    .then(response => {
                        commit('SET_SECCIONES_JER', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpleado(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/empleado', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpleadosParaMemo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/empleadosParaMemo', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllTiposPermiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/allTiposPermiso', { params: data })
                    .then(response => {
                        commit('SET_ALL_TIPOS_PERMISO', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosSalida({ commit }, data) {
            commit('SET_PERMISOS_SALIDA', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/permisosSalida', { params: data })
                    .then(response => {
                        const dataPermisos = response.data.map(e => {
                            e.check = false
                            e.botonDisabled = false
                            return e
                        })
                        commit('SET_PERMISOS_SALIDA', dataPermisos)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postGuardarPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/guardarPermiso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postLiberarPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/liberarPermiso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAtenderPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/noAtenderPermiso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosParaVisualizar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/permisosVisualizar', { params: data })
                    .then(response => {
                        response.data.forEach(tipo => {
                            tipo.permisos.sort((s1, s2) => {
                                if (Math.abs(s1.liberado) > Math.abs(s2.liberado)) {
                                    return 1
                                }
                                if (Math.abs(s1.liberado) < Math.abs(s2.liberado)) {
                                    return -1
                                }
                                return 0
                            })
                        })

                        resolve(true)
                        commit('SET_PERMISOS_PARA_VISUALIZAR', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAnularPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/anularPermiso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposPermiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/tiposPermiso', { params: data })
                    .then(response => {
                        commit('SET_TIPOS_PERMISO', response.data.data)
                        resolve({
                            from: response.data.from,
                            last_page: response.data.last_page,
                            per_page: response.data.per_page,
                            prev_page_url: response.data.prev_page_url,
                            to: response.data.to,
                            total: response.data.total,
                        })
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postLiberarPermisoPorCodigo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/liberarPermisoPorCodigo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPersonalProduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/personalProduccion/', { params: data })
                    .then(response => {
                        commit('SET_PERSONAL_PRODUCCION', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstablecimientosRRHH({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/establecimientosRRHH')
                    .then(response => {
                        commit('SET_ESTABLECIMIENTOS_RRHH', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchFabricasRRHH({ commit }, data) {
            commit('SET_PERMISOS_SALIDA', [])
            commit('SET_PERMISOS_PARA_VISUALIZAR', null)
            commit('SET_FABRICAS_RRHH', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/fabricasRRHH', { params: data })
                    .then(response => {
                        commit('SET_FABRICAS_RRHH', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postIniciarAtencion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/iniciarAtencion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postFinalizarAtencion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/finalizarAtencion', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReportePermisosEmpleados({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/reportePermisosEmpleados', data)
                    .then(response => {
                        commit('SET_REPORTE_PERMISOS_EMPLEADOS', response.data.reporte)
                        resolve(response.data.tiposPermisos)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosEstudio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/permisosEstudio/', { params: data })
                    .then(response => {
                        commit('SET_PERMISOS_ESTUDIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postNoAprobarPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/noAprobarPermiso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAprobarPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/aprobarPermiso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postObtenerDocPermiso(_, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/rrhh/docPermisoEstudio',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        vaciarPermisosParaVisualizar({ commit }) {
            commit('SET_PERMISOS_PARA_VISUALIZAR', null)
        },

        vaciarPermisos({ commit }) {
            commit('SET_PERMISOS_SALIDA', [])
        },

        vaciarEstablecimientos({ commit }) {
            commit('SET_ESTABLECIMIENTOS_RRHH', [])
        },

        vaciarFabricas({ commit }) {
            commit('SET_FABRICAS_RRHH', [])
        },

        fetchDivisiones({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/divisiones')
                    .then(response => {
                        commit('SET_DIVISIONES', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTiposFalta({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/tiposFalta')
                    .then(response => {
                        commit('SET_TIPOS_FALTA', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postGuardarGenerarMemo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/guardarGenerarMemo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchMemorandums(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/memorandums', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchMemorandumsPorUsuario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/memorandumsPorUsuario', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Eileen Sanchez
        fetchEmpresas({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/obtenerEmpresas', { params })
                    .then(response => {
                        commit('SET_EMPRESAS_COMPLEMENTARIAS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarEmpresa(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/agregarEmpresa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarEmpresa(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/editarEmpresa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAnularEmpresa(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/anularEmpresa', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGenerosAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/generosAll')
                    .then(response => {
                        commit('SET_GENEROS_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstadoCivilAll({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/estadoCivilAll')
                    .then(response => {
                        commit('SET_ESTADO_CIVIL_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchComplementarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/obtenerComplementarios', data)
                    .then(response => {
                        commit('SET_EMPLEADOS_COMPLEMENTARIOS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/agregarComplementario', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAgregarComplementarioMasivo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/complementariosMasivo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/editarComplementario', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postAnularComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/anularComplementario', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchComplementariosId(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/complemantariosId', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoCargasFamiliares({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/tipoCargasFamiliares', { params: data })
                    .then(response => {
                        commit('SET_TIPO_CARGA_FAMILIAR', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCargasFamiliaresComplementario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/cargasfamiliarescomplementario', { params: data })
                    .then(response => {
                        commit('SET_CARGA_FAMILIAR_COMPLEMENTARIOS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/complementario', { params: data })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoIdentificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/tipo_identificacion', { params: data })
                    .then(response => {
                        commit('SET_TIPO_IDENTIFICACION', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarCargaComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/agregarCargaFamiliar', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarCargaComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/editarCargaFamiliar', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarCargaFamiliarComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/eliminarCargaFamiliar', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarDocumentoComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/agregarDocumentoComplementarios', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAnularDocumentoComplementario(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/anularDocumentoComplementarios', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postObtenerDocumentoVisual(_, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/rrhh/obtenerDocumentoVisual',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoDocumentos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/tipoDocumentos', { params: data })
                    .then(response => {
                        commit('SET_TIPO_DOCUMENTO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDocumentosComplementarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/documentosComplementarios', { params: data })
                    .then(response => {
                        commit('SET_DOCUMENTOS_COMPLEMENTARIOS', response.data)
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMarcacionesComplementarios(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/marcacionesComplementarios', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTotalDiasComplementarios(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/totalDiasComplementarios', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchComplementariosCombo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/complementariosCombo', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchInformeSemana(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/semanas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchExamenesMedicos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/examenesMedicos', { params: data })
                    .then(response => {
                        commit('SET_EXAMENES_MEDICOS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarExamenMedico(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/agregarExamenMedico', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarExamenMedico(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/editarExamenMedico', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarExamenMedico(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/eliminarExamenMedico', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRolesExamenMedico({ commit }) {
            commit('SET_ROLES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/rolesExamenMedico')
                    .then(response => {
                        commit('SET_ROLES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchExamenXseccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/examenXseccion', { params: data })
                    .then(response => {
                        commit('SET_EXAMEN_X_SECCION', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPermisosEmpresasComplementarios({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/permisosEmpresasCompl')
                    .then(response => {
                        commit('SET_PERMISOS_EMPRESAS_COMP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarPlanClaro(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/guardarPlanClaro', data)
                    // axios({ method: 'post', url: '/api/auth/rrhh/guardarPlanClaro', responseType: 'blob', data: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPlanesClaro(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/planesClaro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConsiliacionPlanes(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/consiliacionPlanes', data)
                    .then(response => {
                        response.data.planes.map(e => {
                            e.det_check = []
                            e.inderteminate = false
                            e.allSelected = false
                            e.show = false
                            e.detalles.map(d => (d.visible = 1))
                            e.planesReduce = () => {
                                return e.detalles.reduce(
                                    (accumulator, currentValue) => accumulator + currentValue.visible,
                                    0
                                )
                            }
                            return e
                        })
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchColaborador(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/colaborador', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchValidarSerial(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/validarSerial', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPdfPlan(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/pdfPlanClaro', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLinea(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/linea', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postTransferirLinea(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/transerirLinea', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarPlan(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/editarPlan', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        putEliminarPlan(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/rrhh/eliminarPlan', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEquiposCelulares() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/equiposCelulares')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        putDesactivarPlan(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/rrhh/desactivarPlan', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCorreosInstitucionales() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/correosInstitucionales')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEncuestas() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/encuestas')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEncuestasPorUsuario() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/encuestasPorUsuario')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGraficosEncuesta(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/graficosEncuesta', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDataEncuesta(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/dataEncuesta', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUsuariosGP() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/usuariosGP')
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstablecimientos() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/establecimientos')
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabricasParaPermisos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/fabricasParaPermisos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGuardarPermisoFabrica(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/guardarPermisoFabrica', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFabricasTiposPermisos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/fabricasTipoPermisos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postActualizarCantidad(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/actualizarCantidad', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postSubirImagenes(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/rrhh/subirImagenes', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchJerarquias({ commit }, data) {
            commit('SET_JERARQUIAS', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/jerarquias', { params: data })
                    .then(response => {
                        commit('SET_JERARQUIAS', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchNaves({ commit }, data) {
            commit('SET_NAVES', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/naves', { params: data })
                    .then(response => {
                        commit('SET_NAVES', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSucursalIess({ commit }) {
            commit('SET_SUCURSAL_IESS', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/sucursalIess')
                    .then(response => {
                        commit('SET_SUCURSAL_IESS', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSubDepartamentos({ commit }, data) {
            commit('SET_SUBDEPARTAMENTOS', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/subDepartamentos', { params: data })
                    .then(response => {
                        commit('SET_SUBDEPARTAMENTOS', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCargos({ commit }, data) {
            commit('SET_CARGOS', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/cargos', { params: data })
                    .then(response => {
                        commit('SET_CARGOS', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTiposContrato({ commit }) {
            commit('SET_TIPOS_CONTRATO', [])
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/tiposContrato')
                    .then(response => {
                        commit('SET_TIPOS_CONTRATO', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAreasSMPROG() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/areasSMPROG')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrdenesTrabajo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/ordenesTrabajo', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchIndicadores(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/rrhh/indicadores', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
